module.exports = __webpack_public_path__ + "img/Sib_Mus_3kl.4565894a.jpg";